import _regeneratorRuntime from 'babel-runtime/regenerator';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(cargarTextosUsuario),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(cargarImagenUsuarioVentana),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(cargarImagenUsuarioLibro),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(cargarImagenUsuario),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(cargarConfiguracionPagina),
    _marked6 =
/*#__PURE__*/
_regeneratorRuntime.mark(cargarConfiguracionPaginas),
    _marked7 =
/*#__PURE__*/
_regeneratorRuntime.mark(gestionarPantalla),
    _marked8 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchPantalla);

import { all, put, takeLatest, select, call } from 'redux-saga/effects';
import { consolidarPantalla, PANTALLA } from '../actions';
import { seleccionarHerramienta } from '../actions/barra-herramientas';
import { GRUPO_PIZARRA, PUNTERO_ID } from '../herramientas/constantes';
import { getHerramientaIdSeleccionado } from '../selectors/barra-herramientas';
import { getNumPaginaIzquierda, getPaginasPorPantalla } from '../selectors/config-libro';
import { configuracionPaginaCargada } from '../actions/index';
import { getEstaPaginaDefinida } from '../selectors/config-paginas';
import * as Util from '../util';
import { cargarImagen } from '../pizarra/actions';
import { PANTALLA_ANTERIOR_ID, PANTALLA_LIBRO_ID, PANTALLA_VENTANA_ID } from '../constantes';
import { getPantalla, getPantallaProps } from '../selectors';
import { cargarTextosZona, cargarTextosDoblePagina } from './textos-usuario';

function cargarTextosUsuario(_ref) {
  var pantallaId = _ref.pantallaId,
      props = _ref.props;
  var libroId, numPagina, libroIdGuardado, numPaginaGuardado, numZonaGuardado;
  return _regeneratorRuntime.wrap(function cargarTextosUsuario$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          libroId = props.libroId, numPagina = props.numPagina, libroIdGuardado = props.libroIdGuardado, numPaginaGuardado = props.numPaginaGuardado, numZonaGuardado = props.numZonaGuardado;
          _context.t0 = pantallaId;
          _context.next = _context.t0 === PANTALLA_VENTANA_ID ? 4 : _context.t0 === PANTALLA_LIBRO_ID ? 7 : 10;
          break;

        case 4:
          _context.next = 6;
          return call(cargarTextosZona, {
            libroIdGuardado: libroIdGuardado,
            numPaginaGuardado: numPaginaGuardado,
            numZonaGuardado: numZonaGuardado
          });

        case 6:
          return _context.abrupt('return');

        case 7:
          _context.next = 9;
          return call(cargarTextosDoblePagina, {
            libroId: libroId,
            numPagina: numPagina
          });

        case 9:
          return _context.abrupt('return');

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function imgPromise(libroId, numPagina) {
  return new Promise(function (resolve) {
    var key = Util.getKeyImagenUsuarioPantallaLibro(libroId, numPagina);
    var dataURL = Util.getStorageData(key);

    if (dataURL) {
      var img = document.createElement('img');
      img.addEventListener('load', function () {
        return resolve(img);
      });
      img.addEventListener('error', function () {
        return resolve(false);
      });
      img.src = dataURL;
    } else {
      resolve(false);
    }
  });
}

function cargarImagenUsuarioVentana(_ref2) {
  var libroIdGuardado = _ref2.libroIdGuardado,
      numPaginaGuardado = _ref2.numPaginaGuardado,
      numZonaGuardado = _ref2.numZonaGuardado;
  var key, dataURL;
  return _regeneratorRuntime.wrap(function cargarImagenUsuarioVentana$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          key = Util.getKeyImagenUsuarioPantallaVentana(libroIdGuardado, numPaginaGuardado, numZonaGuardado);
          dataURL = Util.getStorageData(key);

          if (!dataURL) {
            _context2.next = 7;
            break;
          }

          _context2.next = 5;
          return put(cargarImagen(dataURL));

        case 5:
          _context2.next = 9;
          break;

        case 7:
          _context2.next = 9;
          return put(cargarImagen(null));

        case 9:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function cargarImagenUsuarioLibro(_ref3) {
  var libroId = _ref3.libroId,
      numPagina = _ref3.numPagina;

  var paginasPorPantalla, key, dataURL, numPaginaIzquierda, _ref4, imgIzquierda, imgDerecha, imgRef, canvas, ctx;

  return _regeneratorRuntime.wrap(function cargarImagenUsuarioLibro$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return select(getPaginasPorPantalla, libroId);

        case 2:
          paginasPorPantalla = _context3.sent;

          if (!(paginasPorPantalla === 1)) {
            _context3.next = 10;
            break;
          } //
          // una pagina
          //


          key = Util.getKeyImagenUsuarioPantallaLibro(libroId, numPagina);
          dataURL = Util.getStorageData(key);
          _context3.next = 8;
          return put(cargarImagen(dataURL));

        case 8:
          _context3.next = 32;
          break;

        case 10:
          _context3.next = 12;
          return select(getNumPaginaIzquierda, libroId, numPagina);

        case 12:
          numPaginaIzquierda = _context3.sent;
          _context3.next = 15;
          return all([imgPromise(libroId, numPaginaIzquierda), imgPromise(libroId, numPaginaIzquierda + 1)]);

        case 15:
          _ref4 = _context3.sent;
          imgIzquierda = _ref4[0];
          imgDerecha = _ref4[1];
          imgRef = imgIzquierda || imgDerecha;

          if (!imgRef) {
            _context3.next = 30;
            break;
          }

          canvas = document.createElement('canvas');
          canvas.width = imgRef.naturalWidth * 2;
          canvas.height = imgRef.naturalHeight;
          ctx = canvas.getContext('2d');

          if (imgIzquierda) {
            ctx.drawImage(imgIzquierda, 0, 0, imgIzquierda.naturalWidth, imgIzquierda.naturalHeight, 0, 0, imgIzquierda.naturalWidth, imgIzquierda.naturalHeight);
          }

          if (imgDerecha) {
            ctx.drawImage(imgDerecha, 0, 0, imgDerecha.naturalWidth, imgDerecha.naturalHeight, imgDerecha.width, 0, imgDerecha.naturalWidth, imgDerecha.naturalHeight);
          }

          _context3.next = 28;
          return put(cargarImagen(canvas.toDataURL()));

        case 28:
          _context3.next = 32;
          break;

        case 30:
          _context3.next = 32;
          return put(cargarImagen(null));

        case 32:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function cargarImagenUsuario(_ref5) {
  var pantallaId = _ref5.pantallaId,
      props = _ref5.props;
  return _regeneratorRuntime.wrap(function cargarImagenUsuario$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.t0 = pantallaId;
          _context4.next = _context4.t0 === PANTALLA_VENTANA_ID ? 3 : _context4.t0 === PANTALLA_LIBRO_ID ? 6 : 9;
          break;

        case 3:
          _context4.next = 5;
          return call(cargarImagenUsuarioVentana, props);

        case 5:
          return _context4.abrupt('return');

        case 6:
          _context4.next = 8;
          return call(cargarImagenUsuarioLibro, props);

        case 8:
          return _context4.abrupt('return');

        case 9:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function cargarConfiguracionPagina(libroId, numPagina) {
  var paginaDefinida, configPagina, ficheroConfiguracionPagina;
  return _regeneratorRuntime.wrap(function cargarConfiguracionPagina$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return select(getEstaPaginaDefinida, libroId, numPagina);

        case 2:
          paginaDefinida = _context5.sent;

          if (!paginaDefinida) {
            _context5.next = 5;
            break;
          }

          return _context5.abrupt('return');

        case 5:
          configPagina = void 0;
          ficheroConfiguracionPagina = 'contenido/' + libroId + Util.pad3(numPagina);
          _context5.prev = 7;
          _context5.next = 10;
          return call(Util.loadJson, ficheroConfiguracionPagina);

        case 10:
          configPagina = _context5.sent;
          _context5.next = 16;
          break;

        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5['catch'](7);
          configPagina = {
            "ZONA": []
          };

        case 16:
          _context5.prev = 16;
          _context5.next = 19;
          return put(configuracionPaginaCargada(libroId, numPagina, configPagina));

        case 19:
          return _context5.finish(16);

        case 20:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[7, 13, 16, 20]]);
}

function cargarConfiguracionPaginas(libroId, numPagina) {
  var paginaIzquierda;
  return _regeneratorRuntime.wrap(function cargarConfiguracionPaginas$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return select(getNumPaginaIzquierda, libroId, numPagina);

        case 2:
          paginaIzquierda = _context6.sent;
          _context6.next = 5;
          return call(cargarConfiguracionPagina, libroId, paginaIzquierda);

        case 5:
          _context6.next = 7;
          return call(cargarConfiguracionPagina, libroId, paginaIzquierda + 1);

        case 7:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function gestionarPantalla(action) {
  var herramientaSeleccionada, pantallaActualId, pantallaActualProps, pantallaId, props, pantallaProps, _props, libroId, numPagina;

  return _regeneratorRuntime.wrap(function gestionarPantalla$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return select(getHerramientaIdSeleccionado);

        case 2:
          herramientaSeleccionada = _context7.sent;

          if (!(herramientaSeleccionada !== PUNTERO_ID)) {
            _context7.next = 6;
            break;
          }

          _context7.next = 6;
          return put(seleccionarHerramienta(PUNTERO_ID, GRUPO_PIZARRA));

        case 6:
          _context7.next = 8;
          return select(getPantalla);

        case 8:
          pantallaActualId = _context7.sent;
          _context7.next = 11;
          return select(getPantallaProps, pantallaActualId);

        case 11:
          pantallaActualProps = _context7.sent;
          pantallaId = action.pantallaId, props = action.props;

          if (!(pantallaId === PANTALLA_ANTERIOR_ID)) {
            _context7.next = 18;
            break;
          }

          pantallaId = pantallaActualProps.pantallaAnterior.pantallaId;
          props = _extends({}, pantallaActualProps.pantallaAnterior.props, props || {});
          _context7.next = 23;
          break;

        case 18:
          _context7.next = 20;
          return select(getPantallaProps, pantallaId);

        case 20:
          pantallaProps = _context7.sent;
          props = _extends({}, pantallaProps, props);
          /* si vamos a una pantalla diferente a la actual => guardamos pantalla actual como pantalla anterior */

          if (pantallaId !== pantallaActualId) {
            props.pantallaAnterior = {
              pantallaId: pantallaActualId,
              props: _extends({}, pantallaActualProps)
            };
          }

        case 23:
          /** intentar leer fichero de configuracion de pagina individual si no esta definida (pantallas libro y ventana) */
          // const pantallaProps = yield select(getPantallaProps, pantallaId)
          // let { libroId, numPagina } = pantallaProps || {}
          _props = props, libroId = _props.libroId, numPagina = _props.numPagina; // if (action.props) {
          //     if (action.props.libroId) { libroId = action.props.libroId }
          //     if (action.props.numPagina) { numPagina = action.props.numPagina }
          // }     

          if (!(libroId && numPagina)) {
            _context7.next = 27;
            break;
          }

          _context7.next = 27;
          return call(cargarConfiguracionPaginas, libroId, numPagina);

        case 27:
          _context7.next = 29;
          return call(cargarImagenUsuario, {
            pantallaId: pantallaId,
            props: props
          });

        case 29:
          _context7.next = 31;
          return call(cargarTextosUsuario, {
            pantallaId: pantallaId,
            props: props
          });

        case 31:
          _context7.next = 33;
          return put(consolidarPantalla(pantallaId, props));

        case 33:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function watchPantalla() {
  return _regeneratorRuntime.wrap(function watchPantalla$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return takeLatest(PANTALLA, gestionarPantalla);

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

export default watchPantalla;